/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WorkloadTierConfiguration {
    getFixupPrototypeFunction() { return WorkloadTierConfiguration.fixupPrototype; }

    static newInstance(model: Partial<WorkloadTierConfiguration>): WorkloadTierConfiguration {
        let obj = Object.assign(new WorkloadTierConfiguration(), model);
        WorkloadTierConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WorkloadTierConfiguration>): WorkloadTierConfiguration {
        if (!model) return null;
        return WorkloadTierConfiguration.newInstance(<WorkloadTierConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WorkloadTierConfiguration) {
        if (!obj) return;

        models.WorkloadTierConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WorkloadTierConfiguration): boolean {
        Object.setPrototypeOf(obj, WorkloadTierConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resource_filter) {
            models.QueryOperator.fixupPrototype(this.resource_filter);
        }
    }

    /**
     * Name of the workload tier
     */
    name: string;

    /**
     * Description of the tier
     */
    description: string;

    /**
     * Owner of the tier
     */
    owner: string;

    cloud_account_id: Array<string>;

    resource_filter: models.QueryOperator;

}
